import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import DonationProvider, {
  DonationProviderType,
  GoFundMeDonationFormValueType,
} from '@gik/create/components/DonationProvider/DonationProvider';
import i18n from '@gik/i18n';
import { translationKeys } from '@gik/create/i18n/en';
import { goFundMeFormSchema } from '@gik/create/formSchemas';

export interface IGoFundMeDonationProviderProps {
  value: GoFundMeDonationFormValueType;
  onValueChange: (value: GoFundMeDonationFormValueType) => void;
  asForm?: boolean;
  trackingId?: string;
  variant?: 'create' | 'page-settings';
  recalculateHeightCallback?: () => void;
}

const blockName = 'gofundme-donation-provider';

export default function GoFundMeDonationProvider({
  value,
  onValueChange,
  asForm = false,
  trackingId,
  variant = 'create',
  recalculateHeightCallback,
}: IGoFundMeDonationProviderProps) {
  const bem = bemBlock(blockName);

  return (
    <DonationProvider
      asForm={asForm}
      trackingId={trackingId}
      schema={goFundMeFormSchema()}
      className={bem('content')}
      icon="GoFundMe"
      provider={DonationProviderType.GoFundMe}
      target={
        variant === 'page-settings'
          ? i18n.t(translationKeys.GoFundMeTargetVariantPageSettings)
          : i18n.t(translationKeys.GoFundMeTargetVariantCreate)
      }
      description={
        variant === 'page-settings'
          ? i18n.t(translationKeys.GoFundMeDescriptionVariantPageSettings)
          : i18n.t(translationKeys.GoFundMeDescriptionVariantCreate)
      }
      value={value}
      onValueChange={onValueChange}
      recalculateHeightCallback={recalculateHeightCallback}
    />
  );
}
